import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/imgcaptions/aiLogo.png'


const _hoisted_1 = { class: "im-chat" }
const _hoisted_2 = { class: "im-chat-top" }
const _hoisted_3 = { class: "im-chat-top-title" }
const _hoisted_4 = { class: "im-chat-main" }
const _hoisted_5 = { class: "im-chat-main-left" }
const _hoisted_6 = {
  class: "im-chat-main-box messages",
  id: "message-box"
}
const _hoisted_7 = { style: {"max-width":"100rem"} }
const _hoisted_8 = { class: "im-chat-user" }
const _hoisted_9 = {
  key: 3,
  src: _imports_0
}
const _hoisted_10 = { class: "message-info" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = {
  key: 3,
  class: "rlInfo"
}
const _hoisted_15 = ["onContextmenu"]
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = {
  key: 1,
  class: "rTxtStyle"
}
const _hoisted_18 = {
  key: 5,
  class: "message-info-btn"
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 6,
  class: "message-info-btn"
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  key: 7,
  class: "message-info-btn"
}
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { key: 2 }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "im-chat-footer" }
const _hoisted_35 = { class: "textarea" }
const _hoisted_36 = ["onKeydown"]
const _hoisted_37 = {
  key: 0,
  class: "chatRoomBoxmask"
}
const _hoisted_38 = { class: "chatRoomdelBox" }
const _hoisted_39 = { style: {"max-height":"300px","overflow-y":"scroll","padding":"20px 5px"} }
const _hoisted_40 = { class: "dialog-footer" }

import { useChatStore } from "@/store/chatStore";
import { useUserStore } from "@/store/userStore";
import { aiModelList } from '@/components/common/publicTxt.ts'
import FetchRequest from "@/api/FetchRequest";
import icon from  '@/assets/imgcaptions/aiLogo.png'
import {
  computed,
  getCurrentInstance,
  nextTick,
  onMounted,
  ref,
  watch,
  onBeforeUnmount,
} from "vue";
import Avatar from "@/components/Avatar.vue";
import Time from "@/components/Time.vue";
import Faces from "@/components/Faces.vue";
import HistoryMessage from "@/components/HistoryMessage.vue";
import Chat from "@/mode/Chat";
import Message from "@/mode/Message";
import ChatUtils from "@/utils/ChatUtils";
import ChatType from "@/config/ChatType";
import Upload from "@/components/upload/Upload.vue";
import GroupApi from "@/api/GroupApi";
import User from "@/mode/User";
import MessageApi from "@/api/MessageApi";
import Receipt from "@/mode/Receipt";
import MessageType from "@/utils/MessageType";
import UserApi from "@/api/UserApi";
import ChatImgApi from "@/api/chatImg/Index";
import { storeToRefs } from "pinia";
import { logout } from "@/api/Login";
import showUser from "@/components/user-modal";
import showGroup from "@/components/group-modal";
import RightMenu from "@/components/menu/RightMenu";
import ChatsRadio from "@/components/ChatsRadio";
import { h } from "vue";
import { ElNotification } from "element-plus";
import AccountApi from "@/api/AccountApi";
// markdown插件
import VMdPreview from '@kangc/v-md-editor/lib/preview';
import '@kangc/v-md-editor/lib/style/preview.css';
import githubTheme from '@kangc/v-md-editor/lib/theme/github.js';
import '@kangc/v-md-editor/lib/theme/style/github.css';
// 聊天室
import modelroomApi from "@/api/chatGtp/modelroom.ts";
// highlightjs
import hljs from 'highlight.js';

import {
  Edit,
  Refresh,
  Promotion,
  Operation,
  CloseBold,
  Delete,
  Select,
} from '@element-plus/icons-vue'
import ChatroomApi from "@/api/chatGtp/Chatroom"
import { ElMessage, ElMessageBox } from 'element-plus'
// 引入删除提示
import delbox from "@/components/common/del.vue";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import Auth from "@/api/Auth";

export default /*@__PURE__*/_defineComponent({
  __name: 'ChatgtpMessage',
  props: {
  chatId: {
    type: String,
    required: true,
    default: "",
  },
  imgavatar: {
    type: String,
    required: true,
    default: "",
    // default: "https://t11.baidu.com/it/u=2468644573,209288196&fm=30&app=106&f=JPEG",
  },
  names: {
    type: String,
    required: true,
    default: "",
  },
  modelList:{
    type: Array,
  },
  modelSel:{
      type: String,
    }

},
  emits: ['selOption','sentOption'],
  setup(__props, { emit: __emit }) {

VMdPreview.use(githubTheme, {
  Hljs: hljs,
});


const { proxy } = getCurrentInstance();
const chatStore = useChatStore();
const userStore = useUserStore();
//
const props = __props
onMounted(()=>{
  // console.log('切换===========')
  // console.log('props.modelSel')
  selModel.value=JSON.parse(props.modelSel)
  abortStream()
})
watch(props,(n,o)=>{
  console.log('切换+++++++++++++')
  console.log(props.modelSel)
  abortStream()
  nextTick(()=>{
    console.log(props.modelSel)
    selModel.value=JSON.parse(props.modelSel)
    abortStream()
  })
  
})
const emit = __emit
const selModel=ref()
const handleChange = (value:any) => {
  console.log('切换模型')
  
  let arr=value
  arr.push(props.chatId)
  console.log(arr)
  emit('selOption',arr)
}
// 重新编辑
const reEditTextList = ref([])
const reEditText = (index: number, id: string, content: string) => {
  const reObj = {
    id: id,
    oldcontent: content
  }
  reEditTextList.value.push(reObj)
  console.log(reEditTextList.value)
}
// 撤回重新编辑
const reEditdelText = (id: string) => {
  const index = reEditTextList.value.findIndex(item => item.id == id)
  const content = reEditTextList.value.filter(item => item.id == id)[0].oldcontent
  // console.log(index)
  // console.log(content)
  // 删除
  reEditTextList.value.splice(index, 1)
  // console.log(reEditTextList.value)
  messageList.value.filter(item => item.id == id)[0].content = content
}
// 重新编辑消息
const reContent = (id: string, content: string) => {
  ChatImgApi.Reloadcontent(id, content).then(res => {
    if (res.code == 200) {
      const index = reEditTextList.value.findIndex(item => item.id == id)
      reEditTextList.value.splice(index, 1)
      messageList.value.filter(item => item.id == id)[0].content = content
    }
  })
}
// 打开清除数据弹窗
const delTextword=ref('当前操作会清空所有聊天记录且不可恢复，请确认操作')
const opendelShow=ref(false)
const opendelChat=()=>{
  console.log('打开清除数据弹窗')
  opendelShow.value=true
}
const recognition=()=>{
  opendelShow.value=false
  delChat()
  console.log('请确认操作')
}
// 清空所有消息
const delChat = () => {
  MessageApi.DelemessageAll(props.chatId).then(res => {
        console.log(res)
        if (res.data) {
          messageList.value = []
          ElMessage({
            type: 'success',
            message: '删除成功',
          })
        }

      })
}
// 删除该条消息
const delText = (index: number, id: string) => {

  MessageApi.Delemessage(id).then(res => {
    // console.log(res)
    if (res.data) {
      messageList.value.splice(index, 1)
    }
  })
}



// 获取当前助手chat信息
const assistantChat = chatStore.assistant.filter(item => item.id == props.chatId)[0]
console.log('获取当前助手chat信息')
console.log(userStore.user)
//当前聊天
//  const chatid='1752584054303608834'
const useId = userStore.user.id
// 查询助手聊天历史
const getQueryChatroomhistory = (chatId: string) => {
  ChatroomApi.QueryChatroomhistory(chatId).then(res => {
    // console.log(res.data)
    messageList.value = res.data
    nextTick(() => {
      ChatUtils.imageLoad("message-box");
    });
  })
}

const messageList = ref([])
const messageContent = ref("");

// 发送消息并建立 SSE 连接
// sendMessage
const token = Auth.getToken();
const streamText = ref('');
let reader = null;
let abortController = null;
const noStyle={
  'background':'rgba(99, 163, 249, 0.93)',
  'cursor':'not-allowed'
}
const sentOnoff=ref(true)
const mineSend = async () => {
 if( messageContent.value=="") return
  abortController = new AbortController();
  sentOnoff.value=true
  streamText.value=''
  emit('sentOption',props.chatId)
  try {
    const response = await fetch(FetchRequest.getHost() + '/vim/chatgpt/stream-chat/'+props.chatId, {
      method: 'POST',
      headers: {
         'Content-Type': 'application/json' ,
         Authorization: "Bearer " + token,
        },
      body: JSON.stringify({ content: messageContent.value }),
      // signal: abortController.signal
    });
    
    // 验证响应类型
    if (!response.ok || !response.body) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    messageContent.value=''
     // 创建流处理器
     reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';
    const CHUNK_SIZE = 500; // 每积累500字符更新一次
    let initNum=0
    let partialLine = '';
    let chunk=''
    // 使用异步循环读取数据
    while (initNum<CHUNK_SIZE) {
      
      const { done, value } = await reader.read();
      // console.log(value)
      // console.log(done)
      // 流结束处理
      if (done) {
        // 处理最后缓冲区的剩余数据
        if (buffer.length > 0) {
          streamText.value += buffer;
          console.log(buffer)
          
          // console.log(typeof(buffer))
          // if(){

          // }
          buffer = '';
        }
        break;
      }

      // 解码并缓冲数据
      
      // 分块更新优化（减少响应式更新频率）
      chunk=decoder.decode(value, { stream: true });
      console.log(chunk)
      let lines=''
      if(chunk.endsWith('data:') ||chunk.startsWith('{')){
        console.log(chunk)
        // console.log('======++++======')
        partialLine+=chunk
      } else{
        // console.log('============')
        // console.log(partialLine+ chunk)
        lines = (partialLine+ chunk).split('\n')
        partialLine=''
      }
     
      console.log(lines)
      
      for (const line of lines) {
          if (line.trim() === '') continue;
          if (line.startsWith('data:')) {
              const data = line.replace('data:', '').trim();
              console.log(JSON.parse(data))
              let init=JSON.parse(data)
              let sentData={
                id:'',
                content:'',
                type: "A",
                chatId: "",
                messageType: "0",
                fromId: "0",
                extend:{
                  reasoning:''
                }
              }
              
              if(init.object=='msg'){
                sentData.chatId=init.chatId
                if(props.chatId==sentData.chatId){
                  messageList.value.push(init)
                }
              }else{
                // if(props.chatId==sentData.chatId){
                  if(sentOnoff.value){
                    sentData.id=init.id
                    messageList.value.push(sentData)
                    sentOnoff.value=false
                  }
                  if(init.reasoning!=undefined){
                    // streamText.value+=init.reasoning
                    if(init.reasoning!=undefined &&init.chatId==props.chatId){
                      messageList.value[messageList.value.length-1].extend.reasoning+=init.reasoning
                    }
                    
                  }
                  if(init.content!=undefined && init.chatId==props.chatId){
                    streamText.value+=init.content
                    
                    sentData.content=streamText.value
                    messageList.value[messageList.value.length-1].content=streamText.value
                  }
                // }
                
              }
          }
      }

      nextTick(() => {
        ChatUtils.imageLoad("message-box");
      });

      // console.log(initData.object)
      // if(initData.object=='msg'){
      //   messageList.value.push(JSON.parse(decoder.decode(value, { stream: true })))
      // }else{
      //   buffer += decoder.decode(value, { stream: true });
      //   initNum+=1
      //   console.log(decoder.decode(value, { stream: true }))
      //   if (buffer.length >= CHUNK_SIZE) {
      //     streamText.value += buffer;
      //     buffer = '';
      //     initNum=0
      //   }
      // }
      
    }
  }
   catch (error) {
    console.error('流式请求失败:', error);
    // if (error.name !== 'AbortError') {
    //   console.error('流式请求失败:', error);
    // }
  } finally {
    console.log(messageList.value[messageList.value.length-1].content)
   
    abortController = null;
  }



    
};
// 刷新数据

const reText = async (index: number, id: string) => {
  messageList.value[index].content = ''
  abortController = new AbortController();
  streamText.value=''
  emit('sentOption',props.chatId)
  if(messageList.value[index].extend!=undefined){
    messageList.value[index].extend.reasoning=""
  }
 
  try {
    const response = await fetch(FetchRequest.getHost() + '/vim/chatgpt/refresh/message/'+id, {
      method: 'POST',
      headers: {
         'Content-Type': 'application/x-www-form-urlencoded' ,
         Authorization: "Bearer " + token,
        },
        
    });

    // 验证响应类型
    if (!response.ok || !response.body) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
     // 创建流处理器
     reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';
    const CHUNK_SIZE = 500; // 每积累500字符更新一次
    let initNum=0
    let partialLine = '';
    let chunk=''
    // 使用异步循环读取数据
    while (initNum<CHUNK_SIZE) {
      
      const { done, value } = await reader.read();
      // 流结束处理
      if (done) {
        // 处理最后缓冲区的剩余数据
        if (buffer.length > 0) {
          streamText.value += buffer;
          buffer = '';
        }
        break;
      }

      // 解码并缓冲数据
      // 分块更新优化（减少响应式更新频率）
      chunk=decoder.decode(value, { stream: true });
      let lines=''
      if(chunk.endsWith('data:')||chunk.startsWith('{')){
        // console.log(chunk)
        // console.log('======++++======')
        partialLine+=chunk
      }else{
        // console.log('============')
        // console.log(partialLine+ chunk)
        lines = (partialLine+ chunk).split('\n')
        partialLine=''
      }
     
      // console.log(chunk)
      
      for (const line of lines) {
          if (line.trim() === '') continue;
          if (line.startsWith('data:')) {
              const data = line.replace('data:', '').trim();
              // console.log(JSON.parse(data))
              let init=JSON.parse(data)
              if(init.reasoning!=undefined && init.chatId==props.chatId){
                messageList.value[index].id=init.id
                  // streamText.value+=init.reasoning
                  if(init.reasoning!=undefined){
                    messageList.value[index].content =''
                    messageList.value[index].extend.reasoning+=init.reasoning
                  }
                  
                }
                if(init.content!=undefined && init.chatId==props.chatId){
                  // streamText.value+=init.content
                  messageList.value[index].id=init.id
                  messageList.value[index].content+=init.content
                }
             
          }
      }

      // nextTick(() => {
      //   ChatUtils.imageLoad("message-box");
      // });

      
    }
  }
   catch (error) {
    console.error('流式请求失败:', error);
    // if (error.name !== 'AbortError') {
    //   console.error('流式请求失败:', error);
    // }
  } finally {
    console.log(messageList.value[index].content)
   
    abortController = null;
  }
}
// 手动终止流
const abortStream = () => {
  if (abortController) {
    abortController.abort();
    abortController = null
    streamText.value = '';
  }
};

// 组件卸载时自动终止
onBeforeUnmount(abortStream);
watch(
  props,
  (n) => {
    // console.log('==========')
    // console.log(props.imgavatar)
    messageList.value = []
    messageContent.value = ''
    nextTick(() => {
      getQueryChatroomhistory(props.chatId)
    })

  })
//   const msgget=computed(() => {
//   console.log('聊天记录============ ')
//   console.log(proxy.$ws.onmessage)
//   // console.log(chatStore.chatMessage.get(chat.value.id) ?? new Array<Message>())
//   return  proxy.$ws.onmessage
// });

onMounted(() => {
  getQueryChatroomhistory(props.chatId)
  proxy.$ws.onmessageAssistant = (message: Message) => {
    console.log(message)
    console.log('========助手消息接收====----')
    // 判断是否为该聊天室对话
    if (message.chatId != props.chatId) {
      return
    }

    const onoff = messageList.value.filter(item => item.id == message.id)
    // console.log(onoff)
    if (onoff.length == 0) {//新增消息

      messageList.value.push(message)
      nextTick(() => {
        ChatUtils.imageLoad("message-box");
      });
    } else {
      messageList.value.filter(item => item.id == message.id)[0].content = message.content
    }

  }

})



// /**
//  * 用户点击消息列表某一个人,表示已经读取此人发送的所有的消息
//  */
const readMessage = () => {
  // console.log('用户点击消息列表某一个人,表示已经读取此人发送的所有的消息')
  // console.log(assistantChat)
  if (user) {
    let receipt: Receipt = {
      chatId: assistantChat.id,
      userId: useId,
      timestamp: new Date().getTime(),
      type: assistantChat.type,
    };
    proxy.$ws.sendRead(receipt);
  }
};


const filterResult = ref([])
const handleKeyShow = ref(true)

// 重新发送
const reSend = (id: string) => {
  // console.log(messageList.value)
  delete messageList.value.filter(item => item.id == id)[0].extend
  const onMessage = messageList.value.filter(item => item.id == id)[0]
  // console.log(onMessage)
  ChatImgApi.Reload(id).then((res) => {
    // console.log(res)
  })
}


//是否展示表情
const showFace = ref(false);
//转发
const dialogVisible = ref(false);
//展示用户信息
const show = ref(false);
//群人数
const count = ref(0);

//语音
const Audio = ref();

//控制播放还是暂停音频文件
const handleAudio = (item: Message) => {
  if (Audio.value.paused) {
    Audio.value.src = item.extend.url;
    Audio.value.play();
  } else {
    Audio.value.src = "";
    Audio.value.stop();
  }
};

//用户
const users = ref<Array<User>>();

//是否展示聊天记录
const showHistory = ref(false);

//是否是群成员，如果是群聊天，并且已经被踢出群，不能再有发送按钮
const isGroupUser = ref(true);


const textareaBox = ref()
const keyDown = (e) => {
  if (e.shiftKey && e.code === 'Enter') {
    insertNewLine();
  } else if (e.code === 'Enter') {
    e.cancelBubble = true; //ie阻止冒泡行为
    e.stopPropagation();//Firefox阻止冒泡行为
    e.preventDefault(); //取消事件的默认动作*换行
    // 默认情况下按下Enter键会触发表单提交等操作
    mineSend()
  }
}
const insertNewLine = () => {
  const selectionStart = textareaBox.value.selectionStart;
  const selectionEnd = textareaBox.value.selectionEnd;

  // 获取当前光标位置之前的部分文本
  let beforeCursor = messageContent.value.substring(0, selectionStart);
  // 获取当前光标位置之后的部分文本
  let afterCursor = messageContent.value.substring(selectionEnd);

  // 在光标位置之前插入新的换行符
  beforeCursor += '\n';

  // 更新文本内容
  messageContent.value = beforeCursor + afterCursor;

  // 设置光标位置到新的换行符后面
  setTimeout(() => {
    textareaBox.value.setSelectionRange(beforeCursor.length, beforeCursor.length);
  });
}


const user = userStore.getUser();
if (user) {
  userStore.storeUser(user.id, {
    name: user.name,
    avatar: user.avatar,
  });
}
if (!user) {
  logout().then(() => {
    proxy.$ws.close();
    AccountApi.toLogin();
  });
}
//聊天对象,
const { userMap } = storeToRefs(userStore);
// if (chat.value && chat.value.type === ChatType.FRIEND) {

// UserApi.getUser(props.chatId).then((res) => {
//   const chatUser = res.data;
//   userStore.storeUser(chatUser.id, {
//     name: chatUser.name,
//     avatar: chatUser.avatar,
//   });
// });




return (_ctx: any,_cache: any) => {
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(props.names), 1),
          _createVNode(_component_el_cascader, {
            modelValue: selModel.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selModel).value = $event)),
            options: props.modelList,
            props: props,
            onChange: handleChange,
            "popper-class": "chatStyle",
            placeholder: "选择模型"
          }, null, 8, ["modelValue", "options", "props"])
        ]),
        _createElementVNode("div", {
          class: "titleBtn",
          onClick: _withModifiers(opendelChat, ["stop"])
        }, _cache[7] || (_cache[7] = [
          _createElementVNode("span", null, "全部清空", -1)
        ]))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("ul", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messageList.value, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.id,
                  class: "messagesLi"
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    (item.userType == undefined && _unref(userMap).get(item.fromId)?.avatar != undefined)
                      ? (_openBlock(), _createBlock(Avatar, {
                          key: 0,
                          img: _unref(proxy).getimgUrl+_unref(userMap).get(item.fromId)?.avatar,
                          name: _unref(userMap).get(item.fromId)?.name
                        }, null, 8, ["img", "name"]))
                      : _createCommentVNode("", true),
                    (item.userType != undefined&&props.imgavatar!='')
                      ? (_openBlock(), _createBlock(Avatar, {
                          key: 1,
                          img: _unref(proxy).getimgUrl+props.imgavatar,
                          name: _unref(userMap).get(item.fromId)?.name
                        }, null, 8, ["img", "name"]))
                      : _createCommentVNode("", true),
                    (item.userType == undefined && _unref(userMap).get(item.fromId)?.avatar == undefined&&props.imgavatar!='')
                      ? (_openBlock(), _createBlock(Avatar, {
                          key: 2,
                          img: _unref(proxy).getimgUrl+props.imgavatar,
                          name: _unref(userMap).get(item.fromId)?.name
                        }, null, 8, ["img", "name"]))
                      : _createCommentVNode("", true),
                    (item.fromId=='0'&&_unref(userMap).get(item.fromId)?.avatar == undefined &&props.imgavatar=='')
                      ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_10, [
                      (item.userType == undefined && _unref(userMap).get(item.fromId)?.avatar != undefined)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(userMap).get(item.fromId)?.name), 1))
                        : _createCommentVNode("", true),
                      (item.userType != undefined)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(props.names), 1))
                        : _createCommentVNode("", true),
                      (item.userType == undefined && _unref(userMap).get(item.fromId)?.avatar == undefined)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(props.names), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("i", null, [
                        _createVNode(Time, {
                          time: item.sendTime
                        }, null, 8, ["time"])
                      ]),
                      (item.extend!=undefined && item.extend.reasoning!=undefined&& item.extend.reasoning!='')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, _cache[8] || (_cache[8] = [
                            _createElementVNode("span", null, "已深度思考(R1)", -1)
                          ])))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: "im-chat-text",
                    onContextmenu: _withModifiers(($event: any) => (_ctx.onContextmenu(item, $event)), ["prevent"]),
                    "data-id": "item.id"
                  }, [
                    (item.userType == undefined && _unref(userMap).get(item.fromId)?.avatar != undefined && reEditTextList.value.filter(itom => itom.id == item.id).length == 0)
                      ? (_openBlock(), _createElementBlock("pre", {
                          key: 0,
                          innerHTML: _unref(ChatUtils).transform(item.content)
                        }, null, 8, _hoisted_16))
                      : _createCommentVNode("", true),
                    (item.extend!=undefined && item.extend.reasoning!=undefined)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createVNode(_unref(VMdPreview), {
                            text: item.extend.reasoning.replace('\n', '<br>'),
                            style: {"padding":"0px"}
                          }, null, 8, ["text"]),
                          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "rTxtStyleLine" }, null, -1))
                        ]))
                      : _createCommentVNode("", true),
                    (item.userType != undefined && reEditTextList.value.filter(itom => itom.id == item.id).length == 0)
                      ? (_openBlock(), _createBlock(_unref(VMdPreview), {
                          key: 2,
                          text: item.content.replace('\n', '<br>'),
                          style: {"padding":"10px !important"}
                        }, null, 8, ["text"]))
                      : _createCommentVNode("", true),
                    (item.userType == undefined && _unref(userMap).get(item.fromId)?.avatar == undefined && reEditTextList.value.filter(itom => itom.id == item.id).length == 0)
                      ? (_openBlock(), _createBlock(_unref(VMdPreview), {
                          key: 3,
                          text: item.content.replace('\n', '<br>'),
                          style: {"padding":"10px!important"}
                        }, null, 8, ["text"]))
                      : _createCommentVNode("", true),
                    (reEditTextList.value.filter(itom => itom.id == item.id).length > 0)
                      ? (_openBlock(), _createBlock(_component_el_input, {
                          key: 4,
                          modelValue: item.content,
                          "onUpdate:modelValue": ($event: any) => ((item.content) = $event),
                          type: "textarea",
                          maxlength: "2000",
                          "show-word-limit": "",
                          style: {"width":"50vw"},
                          autosize: { minRows: 4, maxRows: 10 },
                          resize: "none",
                          textareaStyle: "background: red;"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                      : _createCommentVNode("", true),
                    (item.userType == undefined && _unref(userMap).get(item.fromId)?.avatar != undefined)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          (reEditTextList.value.filter(itom => itom.id == item.id).length == 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                                _createVNode(_component_el_icon, { color: "#AAA" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(Delete), {
                                      onClick: ($event: any) => (delText(index, item.id))
                                    }, null, 8, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]))
                            : _createCommentVNode("", true),
                          (reEditTextList.value.filter(itom => itom.id == item.id).length == 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                                _createVNode(_component_el_icon, { color: "#AAA" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(Edit), {
                                      onClick: ($event: any) => (reEditText(index, item.id, item.content))
                                    }, null, 8, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]))
                            : _createCommentVNode("", true),
                          (reEditTextList.value.filter(itom => itom.id == item.id).length > 0)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 2,
                                class: "noBtn",
                                onClick: ($event: any) => (reEditdelText(item.id))
                              }, " 取消 ", 8, _hoisted_21))
                            : _createCommentVNode("", true),
                          (reEditTextList.value.filter(itom => itom.id == item.id).length > 0)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 3,
                                onClick: ($event: any) => (reContent(item.id, item.content)),
                                class: "yesBtn"
                              }, " 确定 ", 8, _hoisted_22))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (item.userType != undefined)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          (reEditTextList.value.filter(itom => itom.id == item.id).length == 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                                _createVNode(_component_el_icon, { color: "#AAA" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(Delete), {
                                      onClick: ($event: any) => (delText(index, item.id))
                                    }, null, 8, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]))
                            : _createCommentVNode("", true),
                          (reEditTextList.value.filter(itom => itom.id == item.id).length == 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                                _createVNode(_component_el_icon, { color: "#AAA" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(Edit), {
                                      onClick: ($event: any) => (reEditText(index, item.id, item.content))
                                    }, null, 8, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]))
                            : _createCommentVNode("", true),
                          (reEditTextList.value.filter(itom => itom.id == item.id).length > 0)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 2,
                                class: "noBtn",
                                onClick: ($event: any) => (reEditdelText(item.id))
                              }, " 取消 ", 8, _hoisted_26))
                            : _createCommentVNode("", true),
                          (reEditTextList.value.filter(itom => itom.id == item.id).length > 0)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 3,
                                onClick: ($event: any) => (reContent(item.id, item.content)),
                                class: "yesBtn"
                              }, " 确定 ", 8, _hoisted_27))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (item.userType == undefined && _unref(userMap).get(item.fromId)?.avatar == undefined)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          (reEditTextList.value.filter(itom => itom.id == item.id).length == 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                                _createVNode(_component_el_icon, { color: "#AAA" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(Delete), {
                                      onClick: ($event: any) => (delText(index, item.id))
                                    }, null, 8, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]))
                            : _createCommentVNode("", true),
                          (reEditTextList.value.filter(itom => itom.id == item.id).length == 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_30, [
                                _createVNode(_component_el_icon, { color: "#AAA" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(Refresh), {
                                      onClick: ($event: any) => (reText(index, item.id))
                                    }, null, 8, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]))
                            : _createCommentVNode("", true),
                          (reEditTextList.value.filter(itom => itom.id == item.id).length == 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_31, [
                                _createVNode(_component_el_icon, { color: "#AAA" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(Edit), {
                                      onClick: ($event: any) => (reEditText(index, item.id, item.content))
                                    }, null, 8, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]))
                            : _createCommentVNode("", true),
                          (reEditTextList.value.filter(itom => itom.id == item.id).length > 0)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 3,
                                class: "noBtn",
                                onClick: ($event: any) => (reEditdelText(item.id))
                              }, " 取消 ", 8, _hoisted_32))
                            : _createCommentVNode("", true),
                          (reEditTextList.value.filter(itom => itom.id == item.id).length > 0)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 4,
                                class: "yesBtn",
                                onClick: ($event: any) => (reContent(item.id, item.content))
                              }, " 确定 ", 8, _hoisted_33))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ], 40, _hoisted_15)
                ]))
              }), 128))
            ]),
            _createElementVNode("audio", {
              ref_key: "Audio",
              ref: Audio
            }, null, 512)
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((messageContent).value = $event)),
                onKeydown: _withKeys(_withModifiers(keyDown, ["exact"]), ["enter"]),
                ref_key: "textareaBox",
                ref: textareaBox,
                placeholder: "想要聊点什么"
              }, null, 40, _hoisted_36), [
                [_vModelText, messageContent.value]
              ]),
              (isGroupUser.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (mineSend())),
                    class: "senBtnBox",
                    style: _normalizeStyle(messageContent.value==''?noStyle:'')
                  }, " 发送 ", 4))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        (opendelShow.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createVNode(delbox, {
                  text: delTextword.value,
                  onCloseThis: _cache[3] || (_cache[3] = ($event: any) => (opendelShow.value = false)),
                  onRecognition: recognition
                }, null, 8, ["text"])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_el_drawer, {
      modelValue: showHistory.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showHistory).value = $event)),
      title: "聊天记录",
      "with-header": false,
      size: "60%"
    }, {
      default: _withCtx(() => [
        _createVNode(HistoryMessage, {
          "from-id": _unref(userStore).user.id,
          "chat-users": _unref(userMap),
          "chat-id": _ctx.chat.id,
          type: _ctx.chat.type,
          showHistory: showHistory.value
        }, null, 8, ["from-id", "chat-users", "chat-id", "type", "showHistory"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_unref(RightMenu), {
      "class-index": 0,
      rightClickInfo: _ctx.rightClickInfo,
      onRetransmission: _ctx.showRetransmission
    }, null, 8, ["rightClickInfo", "onRetransmission"]),
    _createVNode(_component_el_dialog, {
      width: "500px",
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((dialogVisible).value = $event)),
      "show-close": false,
      "destroy-on-close": true,
      title: "消息转发"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_40, [
          _createVNode(_component_el_button, {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (dialogVisible.value = false))
          }, {
            default: _withCtx(() => _cache[10] || (_cache[10] = [
              _createTextVNode("取消")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.retransmission
          }, {
            default: _withCtx(() => _cache[11] || (_cache[11] = [
              _createTextVNode("转发")
            ])),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_39, [
          _createVNode(_unref(ChatsRadio), { onSetData: _ctx.setData }, null, 8, ["onSetData"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})